module.exports = __webpack_public_path__ + "img/pen.3e6f5824.svg";